import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { AnimationItem } from 'lottie-web';
import { AnimationOptions } from 'ngx-lottie';

@Component({
  selector: 'osn-shared-icon-button',
  templateUrl: './icon-button.component.html',
  styleUrls: ['./icon-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconButtonComponent {
  @Input() public iconName?: string;
  @Input() public buttonText?: string;
  @Input() public type: 'primary' | 'secondary' = 'primary';
  @Input() public expandable?: boolean;
  @Input() public previewButton?: boolean;
  @Input() public showLoadingIndicator = false;

  public lottieAnimationOptions: AnimationOptions;
  public animationItem: AnimationItem;

  public onAnimationCreated(animationItem: AnimationItem): void {
    this.animationItem = animationItem;
  }
}
